import styled from 'styled-components'
import { black, textMuted, white } from '@/theme/colors'
import { shadows, radii, motion, layers } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'

export const TooltipContainer = styled.div`
	position: relative;
	display: inline-flex;
	align-items: center;
	cursor: help;
`

export const TooltipIcon = styled.span`
	font-size: ${fontSizes.small};
	color: ${textMuted};
	margin-left: 6px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background: transparent;
	transition: all ${motion.base};

	&:hover {
		color: ${black};
	}
`

export const TooltipText = styled.div<{ $top: number; $left: number; $visible: boolean }>`
	position: fixed;
	top: ${({ $top }) => $top}px;
	left: ${({ $left }) => $left}px;
	visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
	padding: 8px 12px;
	background: ${black};
	color: ${white};
	font-size: ${fontSizes.micro};
	border-radius: ${radii.small};
	z-index: ${layers.popover};
	box-shadow: ${shadows.overlay};
	pointer-events: none;
	width: max-content;
	max-width: 320px;
	white-space: normal;
	text-align: left;
	line-height: ${leading.body};

	&::after {
		content: '';
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		border: 5px solid transparent;
		border-top-color: ${black};
	}
`
